import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./utils/filter";
import axios from 'axios'
// import Antd from 'ant-design-vue';

import SvgIcon from "./components/svgIcon"; // svg组件

// import 'ant-design-vue/dist/antd.less'
import "./global.less"; // global style

const requireAll = (requireContext) =>
  requireContext.keys().map(requireContext);
const req = require.context("./assets/icons/svg", false, /\.svg$/);
requireAll(req);

Vue.component("svg-icon", SvgIcon);
import {
  Table,
  Tabs,
  List,
  Modal,
  FormModel,
  Input,
  message,
  Pagination,
  Button,
  Spin,
  Carousel,
  Timeline,
  Radio
} from "ant-design-vue";
Vue.use(Radio);
Vue.use(Table);
Vue.use(Tabs);
Vue.use(Carousel);
Vue.use(Timeline);
Vue.use(List);
Vue.use(Modal);
Vue.use(FormModel);
Vue.use(Input);
Vue.use(Pagination);
Vue.use(Button);
Vue.use(Spin);
Vue.prototype.$message = message;
Vue.prototype.$http = axios;

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = "宁波市阳光采购服务平台";
  }
  next();
});

new Vue({
  render: (h) => h(App),
  router,
  store,
}).$mount("#app");
